import script from "./AddStudentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStudentModal.vue?vue&type=script&setup=true&lang=js"

import "./AddStudentModal.vue?vue&type=style&index=0&id=e6276836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6276836"]])

export default __exports__